import React from 'react';
import { InfoModalDescriptionTextKeys } from './types';
import { useI18n } from '../../i18n';
import S from './style/InfoModal';

interface InfoModalDescriptionProps {
  descriptionTextKeys: InfoModalDescriptionTextKeys;
}

const InfoModalDescription: React.FC<InfoModalDescriptionProps> = ({ descriptionTextKeys }) => {
  const i18n = useI18n();

  return (
    <>
      <S.Description data-testid="info-modal-description">
        {i18n(descriptionTextKeys.main)}
        {descriptionTextKeys.important && (
          <>
            {' '}
            <strong>{i18n(descriptionTextKeys.important)}</strong>
          </>
        )}
      </S.Description>
      <S.Description data-testid="info-modal-description2">
        {descriptionTextKeys.important2 && <strong>{i18n(descriptionTextKeys.important2)}</strong>}
        {descriptionTextKeys.main2 && <> {i18n(descriptionTextKeys.main2)}</>}
      </S.Description>
      {descriptionTextKeys.newBlock && (
        <S.Description>{i18n(descriptionTextKeys.newBlock)}</S.Description>
      )}
    </>
  );
};

export default InfoModalDescription;
